kwo-modal {
  .Modal {
    position: fixed;
    z-index: 9999;
    right: 0;
    left: 0;
    bottom: 1.2rem;
    top: 170px;
    width: 100%;
    transform: translateX(100%);
    visibility: hidden;
    transition: transform 0.3s, visibility 0.3s;

    @media screen and (max-width: 1200px) {
      top: 1.2rem;
    }

    &.open {
      transform: translateX(0);
      visibility: visible;
    }

    &__container {
      overflow: hidden;
      background-color: #fff;
      box-shadow: 0px 8px 8px 4px rgba(0, 151, 213, 0.10), 0px 0px 12px 12px rgba(0, 0, 0, 0.04);
      height: 100%;
      border-top-left-radius: 2rem;
    }

    &__header {
      position: absolute;
      top: 0;
      right: 1.2rem;
      z-index: 99;
    }

    &__content {
      overflow: auto;
    }

    &__footer {
      @media screen and (max-width: 992px) {
        .btn-tertiary {
          font-size: 0.9rem;
          width: 100%;
          margin-block: 0.3rem;
        }
      }
    }

    &__button {
      font-size: 2rem;
      width: 3rem;
      height: 3rem;
      min-width: unset;
    }

    &__loader {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 2.5rem;
      lg-icon {
        animation: rotate 1s linear infinite;
      }
    }

    @keyframes rotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(-360deg);
      }
    }

    &__emergencyPopup {
      position: fixed;
      z-index: 9999;
      left: 1.2rem;
      bottom: 1.2rem;
    }

    &__backdrop {
      position: fixed;
      z-index: 9998;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s, visibility 0.3s;

      &.open {
        opacity: 1;
        visibility: visible;
      }
    }
  }
}
